export default "__VITE_ASSET__CbHA6Lnz__"